/* tslint:disable */
/* eslint-disable */
/* @relayHash 2083e8f5a2321c48f1313208f8a18efe */

import { ConcreteRequest } from "relay-runtime";
export type ItemEventsShownInput = {
    userId: string;
    clientMutationId?: string | null;
};
export type itemEventsShownMutationVariables = {
    input: ItemEventsShownInput;
};
export type itemEventsShownMutationResponse = {
    readonly itemEventsShown: {
        readonly favoriteNotifications: {
            readonly hasNewEvents: boolean | null;
        } | null;
    } | null;
};
export type itemEventsShownMutation = {
    readonly response: itemEventsShownMutationResponse;
    readonly variables: itemEventsShownMutationVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ItemEventsShownInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasNewEvents",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "itemEventsShownMutation",
    "type": "Mutations",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "itemEventsShown",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ItemEventsShownPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "favoriteNotifications",
            "storageKey": null,
            "args": null,
            "concreteType": "FavoriteNotifications",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "itemEventsShownMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "itemEventsShown",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ItemEventsShownPayload",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "favoriteNotifications",
            "storageKey": null,
            "args": null,
            "concreteType": "FavoriteNotifications",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "mutation",
    "name": "itemEventsShownMutation",
    "id": "ferrum/267.0.0-2020-06-02T15:59:29.433Z/itemEventsShownMutation",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '1282ef6d92da32b74264cdd1393e3f71';
export default node;
